import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.bootstrap4.css";
import "~/styles/tom-select-override.scss";

document.querySelectorAll("select.select2").forEach((el) => {
  const select = el as HTMLSelectElement;
  const group = $(select).closest(".form-group");

  const plugins: string[] = [];
  if (select.multiple) {
    plugins.push("remove_button");
  } else {
    plugins.push("clear_button");
    plugins.push('dropdown_input');
  }
  new TomSelect(select, {
    //plugins: ["remove_button"], //'dropdown_input'
    plugins: plugins,
    maxOptions: 500,
    refreshThrottle: 0,
    render: {
      no_results: function () { return '<div class="no-results">Nincs találat.</div>'; }
    },
    onDropdownOpen() {
      if (window.innerWidth >= 768) return;
      const modal = $(select).closest(".modal");
      if (modal.length) {
        modal.addClass("tomselect-mobile-open");
      } else {
        $(".tomselect-backdrop").addClass("active");
      }
      group.addClass("tomselect-mobile-active");
      // prevent the page behind from scrolling
      $("body").css("overflow", "hidden");
    },
    onDropdownClose() {
      if (window.innerWidth >= 768) return;
      group.removeClass("tomselect-mobile-active");
      $(select).closest(".modal").removeClass("tomselect-mobile-open");
      $(".tomselect-backdrop").removeClass("active");
      $("body").css("overflow", "");
    }
  });
});
